import type { ReactNode } from 'react'

type Props = {
  title: string
  description?: string
  children: ReactNode
  variant?: 'default' | 'danger'
}

export function SettingsSectionCard({ title, description, children, variant = 'default' }: Props) {
  const borderClass =
    variant === 'danger' ? 'border-destructive/40 bg-destructive/5' : 'border-border'

  return (
    <section className={`border rounded-lg p-6 space-y-4 ${borderClass}`}>
      <div>
        <h2
          className={`font-display text-xl font-medium tracking-tight ${
            variant === 'danger' ? 'text-destructive' : ''
          }`}
        >
          {title}
        </h2>
        {description && <p className="text-xs text-muted-foreground mt-1">{description}</p>}
      </div>
      {children}
    </section>
  )
}

export function SettingsUnavailableNotice({ message }: { message: string }) {
  return (
    <div className="text-xs text-muted-foreground italic border border-dashed border-border rounded-md p-3 bg-muted/20">
      {message}
    </div>
  )
}
